import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import Calendar2LineIcon from "remixicon-react/Calendar2LineIcon";
import DownloadCloud2sLineIcon from "remixicon-react/DownloadCloud2LineIcon";
import DatePicker from "react-datepicker";
import Button from "../../../components/utils/Button";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { useForm } from "react-hook-form";
import moment from "moment";

import { Link } from "react-router-dom";
import CardLayout from "../../../components/utils/CardLayout";
import SideButtons from "../../../components/utils/SideButtons";
import SearchBar from "../../../components/utils/SearchBar";
import "react-datepicker/dist/react-datepicker.css";
import Table from "../../../components/utils/Table";
import Modal from "../../../components/utils/Model";
import networkActions from "../../../redux/network/actions";
import authActions from "../../../redux/auth/actions";
import Alert from "../../../components/utils/Alert";
import Tag from "../../../components/utils/Tag";
import {
  isDealer,
  isAdmin,
  isAdminAgent,
  isAdminOrAgent,
  validateIMEI,
  removeSameElementFromArray,
  validateMSISDN,
} from "../../../helpers/commonFunction";
import ChatrBulkActivation from "./ChatrBulkActivation";
import dealerAction from "../../../redux/dealer/actions";
import { convertDateTimeToRequiredFormatTZ } from "../../../helpers/commonFunction";
import ChatractivationActions from "../../../redux/chatrActivation/actions";
import EyeFill from "remixicon-react/EyeFillIcon";
import DataTable from "../../../components/utils/DataTableClient";

function ChatrActivation() {
  const dispatch = useDispatch();
  const { getUserDataByToken } = authActions;
  const { getDealer } = dealerAction;
  const {
    resetChatrMessage,
    getChatrActivationRequestList,
    getChatrBatchTransactionIdRequest,
  } = ChatractivationActions;
  const { getActiveNetwork } = networkActions;
  const { tokenData } = useSelector((state) => state.auth);
  const { networkResult } = useSelector((state) => state.network);
  const dealerResult = useSelector((state) => state.dealer.dealerResult);
  const {
    addChatrBulkActivationMessage,
    chatrActivationLoading,
    chatrActivationResult,
    bulkChatrResultByBatchID,
    bulkChatrResultByBatchIDLoading,
  } = useSelector((state) => state.chatrActivation);
  const [filterText, setFilterText] = useState("");
  const [toDate, setToDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
  );
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");
  const [showBulkActivationForm, setShowBulkActivationForm] = useState(0);
  const [searchData, setSearchData] = useState({
    statusID: "0",
    MSISDN: "",
    fromDate: moment(fromDate).format("YYYY-MM-DD"),
    toDate: moment(toDate).format("YYYY-MM-DD"),
    dealerID: "",
    networkID: "",
  });
  const [networkId, setNetworkId] = useState(0);
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const {
    register: registerFilter,
    handleSubmit: handleSubmit,
    formState: { errors: filterError },
    watch,
    reset,
    setValue: setValueFilter,
  } = useForm({ defaultValues: searchData });
  const [openViewModel, setOpenViewModel] = useState(false);
  const [selectedBatchID, setSelectedBatchID] = useState("");
  const [selectedBatchData, setSelectedBatchData] = useState(null);

  useEffect(() => {
    if (networkResult.length == 1) {
      reset({
        networkID: "1",
      });
    }
  }, [networkResult]);

  const activeNetworks = networkResult?.filter(
    (item) => item.IsActive == 1 && item.ID == 1,
  );

  useEffect(() => {
    if (activeNetworks?.length === 1) {
      setValueFilter("networkID", activeNetworks[0].ID);
    }
  }, [networkResult]);

  useEffect(() => {
    if (
      addChatrBulkActivationMessage !== null &&
      addChatrBulkActivationMessage !== undefined
    ) {
      displayAlert(addChatrBulkActivationMessage, "alert-success");
    }
  }, [addChatrBulkActivationMessage]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
    dispatch(resetChatrMessage());
    dispatch(getUserDataByToken());
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
    dispatch(resetChatrMessage());
    dispatch(getUserDataByToken());
  };

  useEffect(() => {
    const newData = {
      ...searchData,
      toDate: moment(toDate).format("YYYY-MM-DD"),
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };
    dispatch(getChatrActivationRequestList(newData));
  }, []);

  useEffect(() => {
    dispatch(getActiveNetwork());
    dispatch(getDealer());
    dispatch(getUserDataByToken());
    dispatch(resetChatrMessage());
  }, []);

  const handleFilterChange = (value) => {
    setFilterText(value);
  };
  const datePickerRef = useRef(null);
  const datePickerRef2 = useRef(null);

  const openDatePicker = () => {
    datePickerRef.current.setOpen(true);
  };

  const openDatePicker2 = () => {
    datePickerRef2.current.setOpen(true);
  };

  const onSubmit = (data) => {
    const newData = {
      ...data,
      toDate: moment(toDate).format("YYYY-MM-DD"),
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };
    setSearchData(newData);
    dispatch(getChatrActivationRequestList(newData));
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
  };

  const handleNetwork = (e) => {
    e.preventDefault();
    setNetworkId(e.target.value);
  };

  const handleCloseAlert = () => {
    dispatch(resetChatrMessage());
    const newData = {
      ...data,
      toDate: moment(toDate).format("YYYY-MM-DD"),
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };
    dispatch(getChatrActivationRequestList(newData));
  };

  const columns = [
    {
      name: "#",
      selector: (row) => row.id,
      sortable: true,
      width: "80px",
      center: true,
    },
    {
      name: "REFERENCE",
      cell: (row) => (
        <div className="flex flex-col py-2">
          <div>
            <strong>Batch TXNID:</strong>{" "}
            <span
              onClick={() => handleShowTransactionDetails(row)}
              style={{
                cursor: "pointer",
                color: "rgb(0, 76, 164)",
                fontWeight: 600,
                textDecoration: "underline",
              }}
              title="view details"
            >
              {row.batchTransactionId || "-"}
            </span>
          </div>
          <div className="my-2">
            <strong>Dealer Name:</strong> {row.dealername || "-"}
          </div>
          <div>
            <strong>Dealer Email:</strong> {row.dealeremail || "-"}
          </div>
        </div>
      ),
      width: "300px",
    },
    {
      name: "NETWORK",
      selector: (row) => row.network,
      width: "150px",
    },
    {
      name: "QUANTITY",
      cell: (row) => (
        <div style={{ display: "flex", gap: "6px" }}>
          <Tag color="badge-success" title={row.totalprocessed} />
          <Tag color="badge-danger" title={row.totalcancelled} />
          <Tag color="badge-secondary" title={row.quantity} />
        </div>
      ),
      width: "140px",
    },
    ,
    {
      name: "STATUS",
      cell: (row) => {
        switch (row.status) {
          case "Completed":
            return <Tag color="badge-success" title="Completed" />;
          case "Failed":
            return <Tag color="badge-danger" title="Failed" />;
          case "Partial":
          default:
            return <Tag color="badge-secondary" title="Partial" />;
        }
      },
    },

    {
      name: "SUBMITTED DATE",

      selector: (row) => row.submitteddate,

      width: "180px",
    },

    {
      name: "ACTION",
      selector: (row) => row.action,
      cell: (row) => (
        <Link to="#" onClick={() => handleShowTransactionDetails(row)}>
          <span title="View">
            <EyeFill size="1.2em" style={{ color: "#294c28eb" }} />
          </span>
        </Link>
      ),
    },
  ];

  // FILTER
  const filteredItems =
    Array.isArray(chatrActivationResult) && chatrActivationResult.length > 0
      ? chatrActivationResult.filter((item) => {
          if (typeof filterText !== "string" || typeof item !== "object")
            return false;
          // Check if any value in the object contains the filterText
          return Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(filterText.toLowerCase()),
          );
        })
      : [];

  const data = Array.isArray(filteredItems)
    ? filteredItems.map((item, index) => ({
        id: index + 1,
        batchTransactionId: item.BatchTransactionId,
        dealername: item.DealerName,
        dealeremail: item.ContactEmailID,
        network: item.NetworkName,
        totalprocessed: item.TotalSuccessTxn || 0,
        totalcancelled: item.TotalFailedTxn || 0,
        quantity: item.TotalTxn || 0,
        submitteddate:
          item.RequestedDtTm !== null
            ? convertDateTimeToRequiredFormatTZ(item.RequestedDtTm)
            : "",
        status: item.Status,
      }))
    : [];

  const backBulkActivationForm = () => {
    setShowBulkActivationForm(0);
    dispatch(resetChatrMessage());
  };

  const closeBulkTxnModal = () => {
    setOpenViewModel(false);
    alertCancel();
  };
  const handleShowTransactionDetails = (item) => {
    alertCancel();
    setOpenViewModel(true);
    const batchID = item.batchTransactionId;
    setSelectedBatchID(batchID);
    const newData = {
      batchID: batchID,
    };
    setSelectedBatchData(newData);
    dispatch(getChatrBatchTransactionIdRequest(newData));
  };

  // MODAL COLUMNS
  const ModalColumns = [
    { displayName: "#", key: "key" },
    { displayName: "TRANSACTIONID", key: "transactionID" },
    { displayName: "SERIAL NUMBER", key: "serialNumber" },
    { displayName: "AMOUNT", key: "amountCharged" },
    { displayName: "MSISDN", key: "mobileNumber" },
    { displayName: "STATUS", key: "status" },
    { displayName: "REMARK", key: "remark" },
  ];
  // MODAL DATA
  const dataSource =
    bulkChatrResultByBatchID &&
    bulkChatrResultByBatchID.length > 0 &&
    bulkChatrResultByBatchID.map((Item, key) => ({
      key: key + 1,
      transactionID: Item.TransactionID,
      serialNumber: Item.SerialNumber,
      mobileNumber: Item.MSISDN,
      // amountCharged: `$${Item.AmountCharged.toFixed(2)}`,
      amountCharged: `$${Number(Item.AmountCharged ?? 0).toFixed(2)}`,
      status: (
        <Tag
          color={
            Item.RequestStatus === 13
              ? "badge-danger"
              : Item.RequestStatus === 11
                ? "badge-warning"
                : Item.RequestStatus === 12
                  ? "badge-success"
                  : Item.RequestStatus === 32
                    ? "badge-secondary"
                    : "badge-secondary"
          }
          title={Item.StatusDescription}
        />
      ),
      remark: Item.Remark,
    }));

  const listDataModel =
    bulkChatrResultByBatchID?.map((item, key) => ({
      "Sr. No": key + 1,
      "Transaction ID": item.TransactionID,
      "Serial Number": item.SerialNumber,
      MSISDN: item.MSISDN,
      Amount: item.AmountCharged,
      Status: item.StatusDescription,
      Remark: item.Remark,
    })) || [];

  const exportToCSVModal = async () => {
    if (listDataModel && listDataModel.length > 0) {
      const ws = XLSX.utils.json_to_sheet(listDataModel);
      const wb = {
        Sheets: { bulkChatrActivationList: ws },
        SheetNames: ["bulkChatrActivationList"],
      };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      await FileSaver.saveAs(data, "Chatr_Activation_Report" + fileExtension);
    }
  };

  return (
    <>
      {showBulkActivationForm === 1 ? (
        <ChatrBulkActivation
          back={backBulkActivationForm}
          searchData={searchData}
        />
      ) : (
        <>
          <CardLayout title="Chatr Activation">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-row">
                <div className="col-lg-2 col-md-4 mb-2">
                  <label>Select Network</label>
                  <select
                    className="form-control"
                    id="networkID"
                    name="networkID"
                    {...registerFilter("networkID", {})}
                  >
                    {/* <option value="">All</option> */}
                    {networkResult &&
                      networkResult.length > 0 &&
                      networkResult
                        .filter((item) => item.IsActive == 1 && item.ID == 1)
                        .map((item, index) => {
                          return (
                            <option value={item.ID}>{item.NetworkName}</option>
                          );
                        })}
                  </select>
                </div>
                <div className="col-lg-2 col-md-4 mb-2">
                  <label>Select Status</label>
                  <select
                    className="form-control"
                    {...registerFilter("statusID")}
                  >
                    <option value="0">All</option>
                    <option value="1">Completed</option>
                    <option value="2">Failed</option>
                    <option value="3">Partial</option>
                  </select>
                </div>

                {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
                  <div className="col-lg-2 col-md-4  mb-2">
                    <label>Select Dealer</label>
                    <select
                      className="form-control"
                      id="dealerID"
                      name="dealerID"
                      {...registerFilter("dealerID", {})}
                    >
                      <option value="" name="All">
                        All
                      </option>
                      {dealerResult &&
                        dealerResult.length &&
                        dealerResult
                          .filter((item) => item.IsActive == 1 && item.ID !== 1)
                          .map((item) => {
                            return (
                              <option value={item.ID} key={`dealer${item.ID}`}>
                                {item.DealerName}
                              </option>
                            );
                          })}
                    </select>
                  </div>
                )}

                <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                  <label>From Date</label>
                  <Calendar2LineIcon
                    onClick={openDatePicker}
                    size={"1.5rem"}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "36px",
                      right: "12px",
                      zIndex: 1,
                    }}
                  />
                  <DatePicker
                    ref={datePickerRef}
                    selected={fromDate}
                    className="form-control"
                    onChange={(date) => setFromDate(date)}
                    dateFormat="yyyy-MM-dd"
                    name="fromDate"
                    showMonthDropdown
                    showYearDropdown
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                    value={fromDate}
                  />
                </div>

                <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                  <label>To Date</label>
                  <Calendar2LineIcon
                    onClick={openDatePicker2}
                    size={"1.5rem"}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "36px",
                      right: "12px",
                      zIndex: 1,
                    }}
                  />
                  <DatePicker
                    ref={datePickerRef2}
                    selected={toDate}
                    className="form-control center"
                    onChange={(date) => setToDate(date)}
                    dateFormat="yyyy-MM-dd"
                    name="todate"
                    showMonthDropdown
                    showYearDropdown
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                    value={toDate}
                  />
                </div>

                <div className="col-lg-2 col-md-4 mb-2">
                  <label>SIM/Mobile/TXN</label>
                  <input
                    type="text"
                    className="form-control"
                    id="MSISDN"
                    name="MSISDN"
                    placeholder="SIM/Mobile/TXN"
                    {...registerFilter("MSISDN")}
                  />
                </div>

                <div
                  className={
                    isAdmin(tokenData) || isAdminAgent(tokenData)
                      ? "col-lg-2 col-md-4 mb-2"
                      : "col-lg-2 col-md-4"
                  }
                >
                  <div
                    className={
                      isAdmin(tokenData) || isAdminAgent(tokenData)
                        ? "mt-2 d-flex justify-content-start activation-search-btn"
                        : "mt-4"
                    }
                  >
                    <Button
                      title="Search"
                      loading={chatrActivationLoading}
                      style="minWidth:80px"
                      buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`}
                      buttonType="submit"
                    />
                  </div>
                </div>
              </div>
            </form>
            <hr />

            <div className="row mb-3  ">
              <div className="col-lg-3  activation-request-search-btn mb-sm-444">
                <SearchBar
                  onFilter={handleFilterChange}
                  filterText={filterText}
                />
              </div>
              <div className="col-lg-9 d-flex justify-content-end activation-request-action-btn ">
                {isDealer(tokenData) && (
                  <>
                    <SideButtons
                      title="Add Chatr Activation"
                      onClick={() => setShowBulkActivationForm(1)}
                    />
                  </>
                )}
              </div>
            </div>

            {showAlert && (
              <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
            )}
            <div id={"activationRequestTable"}>
              <DataTable
                columns={columns}
                data={data}
                loading={chatrActivationLoading}
                customStyles={{
                  headRow: {
                    style: {
                      backgroundColor: "#FFF5F5",
                    },
                  },

                  headCells: {
                    style: {
                      fontWeight: "bold",
                      fontSize: "14px",
                    },
                  },
                }}
              />
            </div>
          </CardLayout>
        </>
      )}

      <Modal
        showModal={openViewModel}
        title={"Chatr Activation Details : "}
        subTitle={
          <span style={{ color: "rgb(2 77 165)" }}>{selectedBatchID}</span>
        }
        onHide={() => closeBulkTxnModal()}
        width={1000}
        showFooter={false}
      >
        <div className="d-flex justify-content-end">
          {listDataModel && listDataModel.length > 0 && (
            <Button
              onClick={exportToCSVModal}
              title="Export"
              icon={<DownloadCloud2sLineIcon size={15} />}
              style={{ minWidth: "120px" }}
              buttonClass="btn acti-export-btn-v acti-ex-btn font-weight-bold text-white"
            />
          )}
        </div>
        <Table
          columns={ModalColumns}
          loading={bulkChatrResultByBatchIDLoading}
          data={dataSource}
          pagination={false}
        />
      </Modal>
    </>
  );
}

export default ChatrActivation;
